import { VisitorIdService } from "./visitor-id.service";

export class ApiService {
    /**
     * Makes the actual API call, preferably use the get() and post() methods
     *
     * @example
     * <code>
     *     const response = await ApiService.post()
     * @param params
     * @param {string} method
     * @returns {Promise<any>}
     */
    static async fetch(params, method) {
        let body;
        const visitorId = await VisitorIdService.getId();
        const url = new URL(window.location.origin + '/forum/xhr.php');
        const headers = {
            'Content-Type': 'application/json; charset=utf-8',
            'X-Request-Origin': window.location.origin,
            'X-Visitor-Id': visitorId
        };

        method = method.toUpperCase() === 'GET' ? 'GET' : 'POST';

        if(method === 'GET' && params) {
            Object.keys(params).forEach(key => {
                url.searchParams.append(key, encodeURIComponent(params[key]));
            });
        }

        if(method === 'POST' && params) {
            body = JSON.stringify(params)
        }

        const options = {
            method,
            headers,
            body
        };

        try {
            // console.log('>>> fetching', url,  options);
            const response = await fetch(url, options);

            if(!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            // TODO make the return value more elegant
            if(method === 'GET'){
                return response;
            } else {
                return response.json();
            }

        } catch(error) {
            console.error('Error:', error.message);
            throw error;
        }
    }

    static async get(params) {
        return await this.fetch(params, 'get');
    }

    static async post(params) {
        return await this.fetch(params, 'post');
    }
}
